import React from "react"
import {
  Container,
  Heading,
  Box,
  Text,
  Image,
  Grid,
  Flex,
} from "@theme-ui/components"
import ArrowPrimary from "../images/list-arrow-violet.svg"

const HomeListCollection = ({ block }) => {
  console.log(block)
  return (
    <Container sx={{ color: "dark", mt: [4, 4, 4, 7] }}>
      <Grid columns={[1, 1, 1, "1fr 1fr"]} gap={[4, 4, 4, 10]}>
        {block.kicker && (
          <Flex sx={{ flexDirection: "column", gap: 5 }}>
            <Text as="p" sx={{ my: 0, fontSize: "15px" }} variant="kicker">
              {block.kicker}
            </Text>
            <Heading sx={{ fontSize: 4 }} variant="h3">
              {block.title}
            </Heading>
          </Flex>
        )}

        <Box
          sx={{
            color: "primary",
            textTransform: "uppercase",
            fontSize: "16px",
            "& ul": {
              listStyle: "none",
              my: 0,
              padding: 0,
              display: "grid",
              gridTemplateColumns: ["4fr", "4fr", "1fr 1fr"],
              alignContent: "center",

              alignItems: "center",
              "& li": {
                position: "relative",
                width: "100%",
                paddingLeft: "60px",

                my: 2,
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "50%",
                  width: "50px",
                  height: "20px",
                  backgroundImage: `url(${ArrowPrimary})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  transform: "translateY(-50%)",
                },
              },
            },
          }}
          dangerouslySetInnerHTML={{ __html: block.list }}
        />
      </Grid>
    </Container>
  )
}

export default HomeListCollection
